const localStorageLastLocationKey = "itpcrm-last-location";

function getFullPath(location) {
  if (!location || !location.pathname) {
    return null;
  }

  const search = location.search || "";
  const hash = location.hash || "";
  return `${location.pathname}${search}${hash}`;
}

function acceptLocation(location) {
  if (!location || !location.pathname) {
    return false;
  }

  const { pathname } = location;
  if (pathname === "/" || pathname === "/logout" || pathname === "/error") {
    return false;
  }

  if (pathname.startsWith("/auth")) {
    return false;
  }

  return true;
}

function safeSessionStorage() {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return null;
  }
  return window.sessionStorage;
}

export function saveLastLocation(location) {
  if (!acceptLocation(location)) {
    return;
  }

  const fullPath = getFullPath(location);
  if (!fullPath) {
    return;
  }

  const storage = safeSessionStorage();
  if (!storage) {
    return;
  }

  try {
    storage.setItem(localStorageLastLocationKey, fullPath);
  } catch (error) {
    console.warn("Unable to persist last location:", error);
  }
}

export function getLastLocation() {
  const storage = safeSessionStorage();
  if (!storage) {
    return null;
  }

  try {
    return storage.getItem(localStorageLastLocationKey);
  } catch (error) {
    console.warn("Unable to read last location:", error);
    return null;
  }
}

export function forgotLastLocation() {
  const storage = safeSessionStorage();
  if (!storage) {
    return;
  }

  try {
    storage.removeItem(localStorageLastLocationKey);
  } catch (error) {
    console.warn("Unable to clear stored location:", error);
  }
}
